import { Link } from 'react-router';
import type { ToastMessage } from 'primereact/toast';
import { globalToastService } from '@repo/atomic-components';
import { AppRoutes } from '@/constants';
import type { TranscriptionOutcome } from './transcriptionOutcome';

export const TRANSCRIPTION_OUTCOME_TOAST_LIFE_MS = 10 * 1000;

interface TranscriptionOutcomeToast {
  caseId: string;
  /** Left out of the message when unknown. */
  caseReference?: string;
  outcome: TranscriptionOutcome;
}

export function getTranscriptionOutcomeMessage(outcome: TranscriptionOutcome, caseReference?: string): string {
  const message = outcome === 'completed' ? 'Transcription complete' : 'Transcription failed';
  return caseReference ? `${message} on case ${caseReference}` : message;
}

/** Says how a transcription ended. The message links to the case's files. */
export function showTranscriptionOutcomeToast({ caseId, caseReference, outcome }: TranscriptionOutcomeToast) {
  const toast: ToastMessage = {
    severity: outcome === 'completed' ? 'success' : 'error',
    closable: true,
    life: TRANSCRIPTION_OUTCOME_TOAST_LIFE_MS,
    detail: (
      <Link
        to={`/${AppRoutes.Cases}/${caseId}`}
        onClick={() => globalToastService.remove(toast)}
        className="cursor-pointer rounded-sm underline-offset-2 hover:underline focus-visible:underline focus-visible:ring-1 focus-visible:ring-current focus-visible:outline-none"
      >
        {getTranscriptionOutcomeMessage(outcome, caseReference)}
      </Link>
    ),
  };
  globalToastService.show(toast);
}
